import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { MTracingItem } from "../../models/tracing-item-model";
import { SieniService } from "../../services/sieni.service";
import { MOrganizationUser } from "../../models/organization-user.model";
import { MResponsible } from "../../models/responsible.model";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { GlobalsService } from "../../services";

interface IResponsables {
  fase_id: number;
  plazo: number;
  usuario_id: number;
}

@Component({
  selector: "responsible",
  templateUrl: "./responsible.component.html",
  styleUrls: ["./responsible.component.scss"]
})
export class ResponsibleComponent implements OnInit {
  constructor(
    private sieniService: SieniService,
    private globals: GlobalsService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private localeService: BsLocaleService
  ) {}

  @Output() public accept = new EventEmitter<string>();
  @Output() public dismiss = new EventEmitter<string>();
  @Output() public reject = new EventEmitter<string>();
  @Output() public resetResponsibles = new EventEmitter<MResponsible[]>();
  @Input() public item: MTracingItem = null;

  public datepickerConfig;
  public minDate: Date = new Date();
  public date: string = "";
  public users: MOrganizationUser[] = null;
  public responsible1: MResponsible = null;
  public responsible2: MResponsible = null;
  public responsible3: MResponsible = null;
  public responsible4: MResponsible = null;
  public userId1: string = "0";
  public userId2: string = "0";
  public userId3: string = "0";
  public userId4: string = "0";
  public sending: boolean = false;
  private responsables: IResponsables[] = [];

  ngOnInit() {
    // this.item.status.order++
    // console.log(this.translate.currentLang)
    this.translate.setDefaultLang("en");
    this.localeService.use(this.translate.currentLang);
    this.datepickerConfig = {
      showWeekNumbers: false,
      dateInputFormat:
        this.translate.currentLang === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"
    };
    this.minDate = new Date();
    this.responsible1 = this.generateResponsible();
    this.responsible2 = this.generateResponsible();
    this.responsible3 = this.generateResponsible();
    this.responsible4 = this.generateResponsible();
    this.responsible1.limitDate = new Date();
    // console.log(this.item);
    this.sieniService.getCurrentOrganizationUsers().then(res => {
      this.users = res;
      this.item.responsibles.forEach(resp => {
        // console.log(resp);
        switch (resp.fase.id) {
          case 1:
            this.responsible1 = resp;
            this.userId1 = this.responsible1.user.id.toString();
            this.responsible1.limitDate = new Date(this.responsible1.limitDate);
            break;
          case 2:
            this.responsible2 = resp;
            this.userId2 = this.responsible2.user.id.toString();
            if (this.userId2 !== "0") {
              this.responsables.push({
                fase_id: this.responsible2.fase.id || 2,
                plazo: this.responsible2.amountOfDays,
                usuario_id: +this.userId2
              });
            }
            break;
          case 3:
            this.responsible3 = resp;
            this.userId3 = this.responsible3.user.id.toString();
            if (this.userId3 !== "0") {
              this.responsables.push({
                fase_id: this.responsible3.fase.id || 3,
                plazo: this.responsible3.amountOfDays,
                usuario_id: +this.userId3
              });
            }
            break;
          case 4:
            this.responsible4 = resp;
            this.userId4 = this.responsible4.user.id.toString();

            if (this.userId4 !== "0") {
              this.responsables.push({
                fase_id: this.responsible4.fase.id || 4,
                plazo: this.responsible4.amountOfDays,
                usuario_id: +this.userId4
              });
            }
            break;
        }
      });
      // console.log(this.item.responsibles)
    });
  }

  private generateResponsible(): MResponsible {
    return new MResponsible({
      fase: {
        id: 0,
        nombre: "",
        orden: ""
      },
      fecha_limite: "",
      id: 0,
      plazo_dias: 0,
      usuario_responsable: {
        activo: 0,
        usuario: {
          avatar: "",
          email: "",
          id: 0,
          name: "",
          settings: [],
          username: ""
        }
      }
    });
  }

  public onDismiss(text: string) {
    this.dismiss.emit(text);
  }

  public onAccept(text: string) {
    this.accept.emit(text);
  }

  public onReject(text: string) {
    this.reject.emit(text);
  }

  public roundNumber(number: number) {
    return Math.round(number);
  }

  public validateForm(): boolean {
    if (this.userId2 === "0" && this.userId3 === "0" && this.userId4 === "0") {
      return true;
    }
    if (this.item.status.order <= 6) {
      if (this.userId2 !== "0") {
        if (this.responsible2.amountOfDays < 0) {
          return true;
        }
      }
    }
    if (this.item.status.order <= 7) {
      if (this.userId3 !== "0") {
        if (this.responsible3.amountOfDays < 0) {
          return true;
        }
      }
    }
    if (this.item.status.order <= 8) {
      if (this.userId4 !== "0") {
        if (this.responsible4.amountOfDays < 0) {
          return true;
        }
      }
    }
    return false;
  }

  public setResponsibles() {
    this.sending = true;
    let responsibles: IResponsables[] = [];
    if (this.userId2 !== "0") {
      responsibles.push({
        fase_id: this.responsible2.fase.id || 2,
        plazo: this.responsible2.amountOfDays,
        usuario_id: +this.userId2
      });
    }
    if (this.userId3 !== "0") {
      responsibles.push({
        fase_id: this.responsible3.fase.id || 3,
        plazo: this.responsible3.amountOfDays,
        usuario_id: +this.userId3
      });
    }
    if (this.userId4 !== "0") {
      responsibles.push({
        fase_id: this.responsible4.fase.id || 4,
        plazo: this.responsible4.amountOfDays,
        usuario_id: +this.userId4
      });
    }

    // let isChangeInput:boolean = false;
    const respoChanges: IResponsables[] = responsibles.filter((resp, i) => {
      for (const respInitial of this.responsables) {
        if (
          respInitial.fase_id === resp.fase_id &&
          respInitial.usuario_id === resp.usuario_id &&
          respInitial.plazo === resp.plazo
        ) {
          return false;
        }
      }
      return true;
    });

    // console.log(responsibles);
    // console.log(this.responsables)
    if (respoChanges.length > 0) {
      this.sieniService.setResponsibles(this.item.id, responsibles).subscribe(
        res => {
          // console.log(res)
          this.resetResponsibles.emit(res);
          this.accept.emit("Success");
          this.sending = false;
        },
        () => {
          this.toastr.error(
            this.translate.instant("historic.alert.error", {
              name: this.item.title,
              id: this.item.id
            })
          );
          this.sending = false;
        }
      );
    } else {
      this.dismiss.emit("0");
    }
    // console.log(respoChanges)
  }

  public validNumberInput(evt) {
    return (evt.keyCode >= 48 && evt.keyCode <= 57) || evt.keyCode == 8;
  }
}
